import { createFileRoute } from "@tanstack/react-router";

import { CoachProductCreatePage } from "src/pages/CoachProductCreatePage";

export const Route = createFileRoute("/_auth/_coach/products/new")({
  component: CoachProductCreatePage,
  ssr: true,
  staticData: {
    getBreadcrumb() {
      return {
        id: "products-new",
        labelTranslationKey: "productsPage.createTitle",
        href: "/products/new",
      };
    },
  },
});
